const i18nFormatter = require('./i18nFormatter').I18nFormatter;
const isValidDate = require('./dateTimeUtils').isValidDate;
const isValidDateTimeComponentCombinations = require('./dateTimeUtils').isValidDateTimeComponentCombinations;
const isValidDateTimeComponentValues = require('./dateTimeUtils').isValidDateTimeComponentValues;
const getUTCEquivalentSanitizedDateTime = require('./dateTimeUtils').getUTCEquivalentSanitizedDateTime;
const getUTCEquivalentSanitizedDate = require('./dateTimeUtils').getUTCEquivalentSanitizedDate;

const DateTimeFormatter = {
    /**
     * @param date Date object or ISO format date string
     * @param weekday allowable values 'narrow', 'short', 'long'
     * @param era allowable values 'narrow', 'short', 'long'
     * @param year allowable values 'numeric', '2-digit'
     * @param month allowable values 'numeric', '2-digit', 'narrow', 'short', 'long'
     * @param day allowable values 'numeric', '2-digit'
     * @param hour allowable values 'numeric', '2-digit'
     * @param minute allowable values 'numeric', '2-digit'
     * @param second allowable values 'numeric', '2-digit'
     * @param timeZone timeZone for datetime, default value is 'UTC'
     * @param locale default value is 'en-US'
     * @returns {*}
     */
    formatDateTime({date, weekday, era, year, month, day, hour, minute, second, timeZone = 'UTC', locale = 'en_US'}) {
        if (!date) {
            return '';
        }
        if (isValidDate(new Date(date)) && isValidDateTimeComponentValues({weekday, year, month, day, hour, minute, second})
            && isValidDateTimeComponentCombinations({weekday, year, month, day, hour, minute, second})) {
            const sanitizedDate = hour || minute || second ? getUTCEquivalentSanitizedDateTime(date) : getUTCEquivalentSanitizedDate(date);
            return i18nFormatter.formatDateTime({date: sanitizedDate, weekday, era, year, month, day, hour, minute, second, timeZone, locale});
        }
        return date;
    }
};

module.exports = {DateTimeFormatter};
